import { Box } from "@mui/material";
import { OnBoarding } from "../OnBoarding";

export default function NavFooter() {
  return (
    <Box component="footer" data-testid="nav-footer">
      <OnBoarding />
    </Box>
  );
}
